var _root = dcodeIO.ProtoBuf.newBuilder({})['import']({
    "package": "Email.RegisterVerify",
    "options": {
        "objc_class_prefix": "EmailRegisterVerify",
        "java_package": "com.asiainno.uplive.proto"
    },
    "messages": [
        {
            "name": "Request",
            "fields": [
                {
                    "rule": "optional",
                    "type": "string",
                    "name": "verifyCode",
                    "id": 1
                }
            ]
        }
    ]
}).build();

export default _root;


// WEBPACK FOOTER //
// ./js/regi.js